import { Injectable } from '@angular/core';
import { Platform, ToastController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private deferredPrompt: any;
  private installPromptShown = false;
  public canInstall = new BehaviorSubject<boolean>(false);

  // Custom installation prompt content in Arabic
  private readonly INSTALL_TEXT = {
    title: 'ثبّت التطبيق على جهازك',
    subTitle: 'احصل على تجربة التطبيق الكاملة',
    benefits: [
      'استخدم التطبيق مباشرة من شاشة هاتفك الرئيسية',
    //   'لست بحاجة لتحميله من متجر التطبيقات',
      'تحديد موقعك الجغرافي بدقة',
    //   'استخدام حساسات الجهاز (البوصلة، التسارع، ...)',
      'تلقي الإشعارات الفورية',
    //   'العمل بدون إنترنت',
      'مساحة تخزين أقل من التطبيقات العادية',
      'تحديثات تلقائية دائماً'
    ],
    installButton: 'تثبيت الآن',
    cancelButton: 'لاحقاً',
    successMessage: 'تم تثبيت التطبيق بنجاح! يمكنك الوصول إليه من شاشة هاتفك الرئيسية'
  };

  constructor(
    private platform: Platform,
    private toastController: ToastController
  ) {
    this.initInstallPrompt();
  }

  private initInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstall.next(true);
      
      if (!this.installPromptShown) {
        setTimeout(() => {
          this.showCustomInstallPrompt();
        }, 30000);
      }
    });

    window.addEventListener('appinstalled', () => {
      this.installPromptShown = true;
      this.canInstall.next(false);
      this.deferredPrompt = null;
      this.showSuccessToast();
    });
  }

  public async showCustomInstallPrompt(): Promise<boolean> {
    if (!this.deferredPrompt || !this.isInstallable()) {
      return false;
    }

    this.installPromptShown = true;

    const alertController = document.createElement('ion-alert');
    alertController.header = this.INSTALL_TEXT.title;
    alertController.subHeader = this.INSTALL_TEXT.subTitle;
    alertController.cssClass = 'install-prompt-alert';
    alertController.message = `
      <div class="install-benefits" dir="rtl">
        ${this.INSTALL_TEXT.benefits.map(benefit => 
          `<div class="benefit-item">
            <ion-icon name="checkmark-circle" color="success"></ion-icon>
            <span>${benefit}</span>
          </div>`
        ).join('')}
      </div>
    `;
    alertController.buttons = [
      {
        text: this.INSTALL_TEXT.cancelButton,
        role: 'cancel',
        cssClass: 'cancel-button'
      },
      {
        text: this.INSTALL_TEXT.installButton,
        cssClass: 'install-button',
        handler: async () => {
          try {
            this.deferredPrompt.prompt();
            const { outcome } = await this.deferredPrompt.userChoice;
            this.deferredPrompt = null;
            this.canInstall.next(false);
            
            if (outcome === 'accepted') {
              return true;
            }
          } catch (error) {
            console.error('Installation failed:', error);
          }
          return false;
        }
      }
    ];
    
    document.body.appendChild(alertController);
    await alertController.present();

    return false;
  }

  private async showSuccessToast() {
    const toast = await this.toastController.create({
      message: this.INSTALL_TEXT.successMessage,
      duration: 4000,
      position: 'bottom',
      cssClass: 'success-toast',
      buttons: [
        {
          text: '✕',
          role: 'cancel'
        }
      ]
    });
    await toast.present();
  }

  public isInstallable(): boolean {
    return !this.platform.is('ios') && this.canInstall.value && !this.installPromptShown;
  }
}







// import { Injectable } from '@angular/core';
// import { Platform, ToastController } from '@ionic/angular';
// import { BehaviorSubject } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class PwaService {
//   private deferredPrompt: any;
//   private installPromptShown = false;
//   public canInstall = new BehaviorSubject<boolean>(false);

//   // Custom mini-banner content
//   private readonly INSTALL_TEXT = {
//     title: 'تثبيت التطبيق',
//     benefits: [
//       'استخدام بدون تحميل من متجر التطبيقات',
//       'تصفح أسرع',
//       'تجربة أفضل للمستخدم',
//       'تصفح أسرع',
//       'إشعارات فورية'
//     ],
//     installButton: 'تثبيت الآن',
//     cancelButton: 'لاحقاً',
//     successMessage: 'تم تثبيت التطبيق بنجاح!',
//   };

//   constructor(
//     private platform: Platform,
//     private toastController: ToastController
//   ) {
//     this.initInstallPrompt();
//   }

//   private initInstallPrompt() {
//     window.addEventListener('beforeinstallprompt', (e: any) => {
//       e.preventDefault();
//       this.deferredPrompt = e;
//       this.canInstall.next(true);
      
//       if (!this.installPromptShown) {
//         setTimeout(() => {
//           this.showCustomInstallPrompt();
//         }, 30000);
//       }
//     });

//     window.addEventListener('appinstalled', () => {
//       this.installPromptShown = true;
//       this.canInstall.next(false);
//       this.deferredPrompt = null;
//       this.showSuccessToast();
//     });
//   }

//   private async showSuccessToast() {
//     const toast = await this.toastController.create({
//       message: this.INSTALL_TEXT.successMessage,
//       duration: 3000,
//       position: 'bottom',
//       cssClass: 'success-toast',
//       buttons: [
//         {
//           text: '✕',
//           role: 'cancel'
//         }
//       ]
//     });
//     await toast.present();
//   }

//   public async showCustomInstallPrompt(): Promise<boolean> {
//     if (!this.deferredPrompt || !this.isInstallable()) {
//       return false;
//     }

//     this.installPromptShown = true;

//     // Create and show custom install modal
//     const alertController = document.createElement('ion-alert');
//     alertController.header = this.INSTALL_TEXT.title;
//     alertController.message = this.INSTALL_TEXT.benefits.map(benefit => `• ${benefit}`).join('<br>');
//     alertController.buttons = [
//       {
//         text: this.INSTALL_TEXT.cancelButton,
//         role: 'cancel'
//       },
//       {
//         text: this.INSTALL_TEXT.installButton,
//         handler: async () => {
//           try {
//             this.deferredPrompt.prompt();
//             const { outcome } = await this.deferredPrompt.userChoice;
//             this.deferredPrompt = null;
//             this.canInstall.next(false);
            
//             if (outcome === 'accepted') {
//               // Success toast will be shown by appinstalled event
//               return true;
//             }
//           } catch (error) {
//             console.error('Installation failed:', error);
//           }
//           return false;
//         }
//       }
//     ];
    
//     document.body.appendChild(alertController);
//     await alertController.present();

//     return false;
//   }

//   public isInstallable(): boolean {
//     return !this.platform.is('ios') && this.canInstall.value && !this.installPromptShown;
//   }
// }









// // import { Injectable } from '@angular/core';
// // import { Platform } from '@ionic/angular';
// // import { BehaviorSubject } from 'rxjs';

// // @Injectable({
// //   providedIn: 'root'
// // })
// // export class PwaService {
// //   private deferredPrompt: any;
// //   private installPromptShown = false;
// //   public canInstall = new BehaviorSubject<boolean>(false);

// //   constructor(private platform: Platform) {
// //     this.initInstallPrompt();
// //   }

// //   private initInstallPrompt() {
// //     // Listen for beforeinstallprompt event
// //     window.addEventListener('beforeinstallprompt', (e: any) => {
// //       // Prevent Chrome 67 and earlier from automatically showing the prompt
// //       e.preventDefault();
// //       // Stash the event so it can be triggered later
// //       this.deferredPrompt = e;
// //       this.canInstall.next(true);
      
// //       // Start 30s timer if not already shown
// //       if (!this.installPromptShown) {
// //         setTimeout(() => {
// //           this.showInstallPrompt();
// //         }, 30000); // 30 seconds delay
// //       }
// //     });

// //     // Listen for app installed event
// //     window.addEventListener('appinstalled', () => {
// //       this.installPromptShown = true;
// //       this.canInstall.next(false);
// //       this.deferredPrompt = null;
// //       console.log('PWA was installed');
// //     });
// //   }

// //   public async showInstallPrompt(): Promise<boolean> {
// //     if (!this.deferredPrompt) {
// //       console.log('No installation prompt available');
// //       return false;
// //     }

// //     // Mark as shown
// //     this.installPromptShown = true;

// //     // Show the prompt
// //     this.deferredPrompt.prompt();

// //     // Wait for the user to respond to the prompt
// //     const { outcome } = await this.deferredPrompt.userChoice;
    
// //     // Clear the prompt reference
// //     this.deferredPrompt = null;
// //     this.canInstall.next(false);

// //     return outcome === 'accepted';
// //   }

// //   public isInstallable(): boolean {
// //     return !this.platform.is('ios') && this.canInstall.value && !this.installPromptShown;
// //   }
// // }